module.exports = __webpack_public_path__ + "img/bbl.f201993f.png";